import React from 'react';
import { motion } from 'framer-motion';
import { Lock, Zap, ShieldCheck } from 'lucide-react';
export function ClosingSection() {
  const scrollToCTA = () => {
    const cta = document.getElementById('cta-section');
    if (cta) cta.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="py-8 md:py-14 px-4 md:px-6 text-center border-t border-[var(--border-subtle)]" style={{
    backgroundColor: 'var(--bg-deep)'
  }} data-id="element-131">
      <div className="max-w-[680px] mx-auto space-y-3 md:space-y-5" data-id="element-132">
        <h2 className="text-xl md:text-3xl font-serif text-[var(--text-heading)] leading-snug" data-id="element-133">
          Tienes dos caminos hoy:
        </h2>

        <div className="space-y-3 text-base md:text-lg text-[var(--text-muted)] font-light text-left max-w-lg mx-auto bg-[var(--bg-card)] p-4 md:p-6 rounded-xl border border-[var(--border-subtle)]" data-id="element-134">
          <p data-id="element-135">
            <strong className="text-[var(--text-heading)]" data-id="element-136">Camino A:</strong>{' '}
            Seguir intentando descifrar el silencio de Dios por tu cuenta,
            cargando el peso de la incertidumbre un día más.
          </p>
          <div className="w-full h-px bg-[var(--border-subtle)]" data-id="element-137"></div>
          <p data-id="element-138">
            Invertir solo $14.36 y permitir que esta guía sea el mapa que te
            ayude a encontrar propósito en tu dolor.
          </p>
        </div>

        <p className="text-[var(--text-primary)] font-serif italic text-lg md:text-xl pt-2" data-id="element-139">
          Haz clic abajo y comienza tu Día 1 ahora mismo.
        </p>

        <div className="pt-2 space-y-2" data-id="element-140">
          <motion.button onClick={scrollToCTA} whileHover={{
          scale: 1.03
        }} whileTap={{
          scale: 0.97
        }} className="inline-flex items-center gap-2 px-8 py-4 md:py-5 bg-gradient-to-r from-[var(--accent)] to-[var(--accent-hover)] text-[#faf7f2] font-extrabold md:text-base rounded-lg shadow-md uppercase tracking-wide w-full md:w-auto justify-center whitespace-nowrap text-[11px]" data-id="element-141">
            SÍ, QUIERO EMPEZAR MI RECONSTRUCCIÓN POR $14.36
          </motion.button>

          <div className="flex items-center justify-center gap-3 text-[10px] text-[var(--text-muted)] mt-2 flex-wrap" data-id="element-142">
            <span className="flex items-center gap-1" data-id="element-143">
              <Lock className="w-3 h-3" data-id="element-144" /> Pago Seguro
            </span>
            <span className="opacity-30" data-id="element-145">|</span>
            <span className="flex items-center gap-1" data-id="element-146">
              <Zap className="w-3 h-3" data-id="element-147" /> Acceso inmediato a tu correo
            </span>
          </div>
        </div>
      </div>
    </section>;
}